var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-wrapper"},[_c('input',{staticClass:"search-input",on:{"input":_vm.onInput}}),_c('div',{staticClass:"icon-wrapper"},[_c('div',{staticClass:"icon-holder"},[_c('MdIcon',{attrs:{"size":"sm","name":"magnify"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }